import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { hideModal } from 'appSrc/redux/actions';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import ProductForm from './ProductForm';


class EditProductModal  extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    submit = ( updates ) => {
        this.setState( { fetching: true } );
        delete updates.product.views;
        delete updates.product.searches;
        delete updates.product.shares;
        //handle featured toggle
        updates.product.featured = !updates.product.featured ? false : this.props.product.featured ? undefined : true;
        this.props.onSubmit( updates )
        .then( () => {
            this.setState( { fetching: false } );
            this.props.closeModal();
        } );
    }
    render() {
        const { modalName, modalProps } = this.props;
        let goodToGo = false;
        if ( modalName === 'editProductModal' ) {
            goodToGo = true;
        }
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Edit Product"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Edit Product</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <ProductForm onSubmit={ this.submit } initialValues={ this.props.product } />
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'editProductModal' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( EditProductModal );
